import type { GeoObjectOptions, GeoObjectTypes, Materials, RawDataGroup } from '@visualizer/types';
import { PreProcessingTypes } from '@visualizer/types';
import { GeoObjectSingleMesh } from '@data/geodata/GeoObjectSingleMesh';
import * as THREE from 'three';

interface Options<T extends GeoObjectTypes> extends GeoObjectOptions<T> {
    data: RawDataGroup[];
}

export class TreesSingleMesh extends GeoObjectSingleMesh<[PreProcessingTypes.TREES]> {
    constructor({ name, colors, data, mode }: Omit<Options<[PreProcessingTypes.TREES]>, 'types'>) {
        super({ name, colors, mode, thresholdAngle: 10, data, types: [PreProcessingTypes.TREES] });
    }

    protected override createMaterials(): Materials<[PreProcessingTypes.TREES]> {
        return {
            trees: {
                material: new THREE.MeshBasicMaterial({
                    color: 0x0,
                    side: THREE.DoubleSide,
                    polygonOffset: true,
                    depthTest: true,
                    polygonOffsetFactor: 3,
                    polygonOffsetUnits: 3,
                }),
                shadowMaterial: new THREE.MeshLambertMaterial({ color: 0x0, side: THREE.DoubleSide }),
                stroke: new THREE.LineBasicMaterial({
                    color: 0x0,
                    linewidth: 1,
                }),
            },
        };
    }
}
